import { useEffect, useMemo } from "react";

import { UseQueryResult } from "@tanstack/react-query";

import { EditorialDetailsPageHookProps } from "@companion-core/shared/app/Components/DetailsPages/EditorialDetailsPage/EditorialDetailsPage.model";
import { useDetailsPage } from "@companion-core/shared/app/Components/DetailsPages/hooks/detailsPage";
import { APIContentComponent, APIVendorComponent } from "@companion-core/shared/app/Interfaces/API";
import { useDetailPage } from "@companion-core/shared/app/Queries/detailPage";
import { trackDynamicPage } from "@companion-core/shared/app/tracking/dynamicPage";
import {
  getDynamicComponentId,
  getDynamicComponentVendorId,
} from "@companion-core/shared/app/Utils/tracking";

export const useEditorialDetailsPage = ({ id, origin }: EditorialDetailsPageHookProps) => {
  const { lang } = useDetailsPage();
  const {
    data,
    isFetching,
    isPending,
  }: UseQueryResult<(APIContentComponent & APIVendorComponent) | null, unknown> = useDetailPage<
    APIContentComponent & APIVendorComponent
  >({
    parentID: id ?? "",
    lang,
    contentType: "editorial",
  });

  const editorialType = useMemo(() => data?.type, [data]);

  useEffect(() => {
    if (data) {
      trackDynamicPage({
        pageSlug: origin,
        contentId: getDynamicComponentId(data),
        vendorId: getDynamicComponentVendorId(data),
      });
    }
  }, [data]);

  return {
    lang,
    data,
    isFetching,
    isPending,
    editorialType,
    isError: data === null,
  };
};
